import React, { useCallback } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';

import {
  orderedMenteeModulesSelector,
  setMenteeModules,
  updateMenteeModuleOrder,
} from 'features/moduleManagement';

function MenteeModulesDragDrop({ children, orderedCoreMenteeModules }) {
  const dispatch = useDispatch();
  const orderedMenteeModules = useSelector(orderedMenteeModulesSelector);

  const handleDragEnd = useCallback(
    (result) => {
      // dropped outside the list
      if (!result.destination) {
        return;
      }

      // no movement
      if (result.destination.index === result.source.index) {
        return;
      }

      const sourceMenteeModule = orderedCoreMenteeModules[result.source.index];
      const destMenteeModule =
        orderedCoreMenteeModules[result.destination.index];

      // We expect draggableId and source id to be same else something is
      // very wrong and we simply avoid making any changes.
      if (String(sourceMenteeModule.id) !== result.draggableId) {
        return;
      }

      // If there is no destination class then also something is wrong so
      // we avoid making any changes.
      if (!destMenteeModule) {
        return;
      }

      const updatedCoreMenteeModules = updateMenteeModuleOrder({
        menteeModules: orderedCoreMenteeModules,
        menteeModuleId: sourceMenteeModule.id,
        newOrder: destMenteeModule.order,
      });
      const updatedMenteeModules = orderedMenteeModules.map((menteeModule) => {
        const coreMenteeModule = updatedCoreMenteeModules.find(
          (mm) => mm.id === menteeModule.id
        );
        return coreMenteeModule ?? menteeModule;
      });

      dispatch(setMenteeModules(updatedMenteeModules));
    },
    [dispatch, orderedCoreMenteeModules, orderedMenteeModules]
  );

  return (
    <DragDropContext onDragEnd={handleDragEnd}>{children}</DragDropContext>
  );
}

export default MenteeModulesDragDrop;
